<template>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
      <vs-button color="primary" v-if="params.data.status !== 0" @click="setEndOfHole()">{{ params.data.status === 2 ? $t('Drilling.Holes.ReverseEndOfHole') : $t('Drilling.Holes.EndOfHole') }}</vs-button>
    </div>
</template>

<script>
export default {
  name: 'HoleActionsCellRenderer',
  methods: {
    setEndOfHole () {
      this.params.context.componentParent.setEndOfHole(this.params.data.holeId, !this.params.data.latestIsEndOfHole, true);
    }
  }
}
</script>
